import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "row"
};
const _hoisted_2 = { class: "col-md-12" };
const _hoisted_3 = { class: "mb-3 error__message-container" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.hasErrors(_ctx.$form.rules))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterErrors(_ctx.$form.rules), (item, index) => {
                        return (_openBlock(), _createElementBlock("div", null, _toDisplayString(item.message), 1));
                    }), 256))
                ])
            ])
        ]))
        : _createCommentVNode("", true);
}
